import React from 'react';
import { Stack, Typography, Button, useTheme, styled } from '@mui/material';
import { Box } from '@mui/system';

const BackgroundStack = styled(Stack)`
  background-image: url(/images/press-center/get-in-touch-bg.png);
`;

function GetInTouch() {
  const theme = useTheme();

  return (
    <BackgroundStack
      sx={{
        paddingY: { xs: theme.spacing(22.5), md: theme.spacing(14.5) },
        paddingX: { xs: theme.spacing(6), md: 0 },
      }}
    >
      <Typography
        variant="h2"
        color={theme.palette.warning.contrastText}
        textAlign="center" 
        sx={{
          fontSize: { xs: '2.375rem !important', md: '3.125rem !important' },
          lineHeight: { xs: '1.2 !important', md: '1.18 !important' },
        }}
      >
        Get in Touch
      </Typography>

      <Box marginTop={theme.spacing(2.5)}>
        <Typography
          fontWeight={700}
          variant="body2"
          color={theme.palette.warning.contrastText}
          textAlign="center"
          sx={{
            fontSize: { xs: '1.125rem !important', md: '1.4375rem !important' },
            lineHeight: { xs: '1.46 !important', md: '1.4 !important' },
          }}
        >
          If you’re a member of the press, contact us at <a href="mailto:press@onevillage.io">press@onevillage.io</a>
        </Typography>
      </Box>

      <Stack
        sx={{
          marginTop: theme.spacing(6),
          alignItems: 'center',
        }}
      >
        <Button
          component="a"
          href="mailto:press@onevillage.io"
          variant="contained"
          color="secondary"
          sx={{
            paddingX: theme.spacing(9),
            color: theme.palette.grey[900],
            minWidth: theme.spacing(41),
          }}
        >
          Contact Us
        </Button>
      </Stack>
    </BackgroundStack>
  );
}

export default GetInTouch;
